import React, { useContext, createContext, useMemo, ReactNode } from 'react';
import create from 'zustand';

interface AppContextProps {
  studioToolbarOpen: boolean;
  bannerVisible: boolean;
  setStudioToolbarOpen: (open: boolean) => void;
  setBannerVisible: (open: boolean) => void;
}

const getInitialState = (): AppContextProps => ({
  studioToolbarOpen: false,
  bannerVisible: false,
  setStudioToolbarOpen: () => {},
  setBannerVisible: () => {},
});

const AppContext = createContext<AppContextProps>(getInitialState());
AppContext.displayName = 'AppContext';

const usePersistentState = create<ReturnType<typeof getInitialState>>(set => ({
  studioToolbarOpen: false,
  bannerVisible: false,
  setStudioToolbarOpen: (open: boolean) =>
    set(() => ({ studioToolbarOpen: open })),
  setBannerVisible: (visible: boolean) =>
    set(() => ({ bannerVisible: visible })),
}));

export const AppProvider = ({ children }: { children: ReactNode }) => {
  const state = usePersistentState();
  const memoizedState = useMemo(() => {
    return { ...state };
  }, [state]);

  return (
    <AppContext.Provider value={memoizedState}>{children}</AppContext.Provider>
  );
};

export function useAppContext() {
  return useContext(AppContext);
}

export default AppContext;
